import React, { useEffect, useState } from 'react';
import jsVectorMap from 'jsvectormap';
import 'jsvectormap/dist/maps/world.js';
import 'jsvectormap/dist/jsvectormap.min.css';
import { Card, CardHeader, CardHeaderBtn, CardBody } from './../../components/card/card.jsx';
import Chart from 'react-apexcharts';
import { Icon } from '@iconify/react';

function Dashboard() {
	const [statsData, setStatsData] = useState();
	const [trafficData, setTrafficData] = useState();
	const [securityData, setSecurityData] = useState();
	const [threatData, setThreatData] = useState();
	const [businessData, setBusinessData] = useState();
	const [salesData, setSalesData] = useState();
	const [operationalData, setOperationalData] = useState();
	const [socialData, setSocialData] = useState();
	const [productsData, setProductsData] = useState();
	const [marketingData, setMarketingData] = useState();
	const [chartOptions, setChartOptions] = useState();
	
	function getChartOptions() {
		var themeRgb = (getComputedStyle(document.body).getPropertyValue('--bs-theme-rgb')).trim();
		
		return {
			chart: { sparkline: { enabled: true } },
			colors: ['rgba('+ themeRgb + ', .95)', 'rgba('+ themeRgb + ', .35)',],
			stroke: { show: false },
			tooltip: { y: { title: { formatter: function (seriesName) { return ''; } } } }
		};
	}
  
  function renderMap() {
		var theme = (getComputedStyle(document.body).getPropertyValue('--bs-theme')).trim();
		var white = (getComputedStyle(document.body).getPropertyValue('--bs-white')).trim();
		var whiteRgb = (getComputedStyle(document.body).getPropertyValue('--bs-white-rgb')).trim();
		var bodyFontFamily = (getComputedStyle(document.body).getPropertyValue('--bs-body-font-family')).trim();
		const elm = document.getElementById('map-container');
		const mapElm = document.querySelectorAll('.jvm-tooltip');
		
		if (mapElm) {
			for (let i = 0; i < mapElm.length; i++) {
				mapElm[i].remove();
			}
		}
		if (elm) {
			elm.innerHTML = '<div id="map"></div>';
			new jsVectorMap({
				selector: '#map',
				map: 'world',
				zoomButtons: true,
				normalizeFunction: 'polynomial',
				hoverOpacity: 0.5,
				hoverColor: false,
				zoomOnScroll: false,
				series: { regions: [{ normalizeFunction: 'polynomial' }] },
				labels: { markers: { render: (marker) => marker.name } },
				focusOn: { x: 0.5, y: 0.5, scale: 1 },
				markers: [
					{ name: "Egypt", coords: [26.8206, 30.8025] },
					{ name: "Russia", coords: [61.524, 105.3188] },
					{ name: "Canada", coords: [56.1304, -106.3468] },
					{ name: "Greenland", coords: [71.7069, -42.6043] },
					{ name: "Brazil", coords: [-14.235, -51.9253] }
				],
				markerStyle: { initial: { fill: theme, stroke: 'none', r: 5 }, hover: { fill: theme } },
				markerLabelStyle: { initial: { fontFamily: bodyFontFamily, fontSize: '10px', fill: 'rgba('+ whiteRgb + ', .75)' } },
				regionStyle: { initial: { fill: white, fillOpacity: 0.35, stroke: 'none', strokeWidth: 0.4, strokeOpacity: 1 }, hover: { fillOpacity: 0.5 } },
				backgroundColor: 'transparent',
			});
		}
  }
  
  useEffect(() => {
		setChartOptions(getChartOptions());
		
		fetch('/quantum-react/assets/data/dashboard/stats.json').then(res => res.json()).then((result) => { setStatsData(result); });
		fetch('/quantum-react/assets/data/dashboard/traffic.json').then(res => res.json()).then((result) => { setTrafficData(result); });
		fetch('/quantum-react/assets/data/dashboard/security.json').then(res => res.json()).then((result) => { setSecurityData(result); });
		fetch('/quantum-react/assets/data/dashboard/threat.json').then(res => res.json()).then((result) => { setThreatData(result); });
		fetch('/quantum-react/assets/data/dashboard/business.json').then(res => res.json()).then((result) => { setBusinessData(result); });
		fetch('/quantum-react/assets/data/dashboard/sales.json').then(res => res.json()).then((result) => { setSalesData(result); });
		fetch('/quantum-react/assets/data/dashboard/operational.json').then(res => res.json()).then((result) => { setOperationalData(result); });
		fetch('/quantum-react/assets/data/dashboard/social.json').then(res => res.json()).then((result) => { setSocialData(result); });
		fetch('/quantum-react/assets/data/dashboard/products.json').then(res => res.json()).then((result) => { setProductsData(result); });
		fetch('/quantum-react/assets/data/dashboard/marketing.json').then(res => res.json()).then((result) => { setMarketingData(result); });
		
		renderMap();
		
		document.addEventListener('theme-reload', () => {
			renderMap();
			setChartOptions(getChartOptions());
		});
		
		return function cleanUp() {
			const mapElm = document.querySelectorAll('.jvm-tooltip');
		
			if (mapElm) {
				for (let i = 0; i < mapElm.length; i++) {
					mapElm[i].remove();
				}
			}
		}
		
		// eslint-disable-next-line
  }, []);
	
	return (
		<div className="row g-2">
			<div className="col-xl-12">
				<div className="row g-2">
					{statsData && statsData.map((stat, index) => (
						<div className="col-xl-2 col-lg-4 col-6" key={index}>
							<Card className="h-100">
								<CardHeader>{stat.title}</CardHeader>
		
								<CardBody>
									<div className="h4 fw-100 text-theme mb-1">{stat.value}</div>
									<p className="text-white fs-10px mb-0">{stat.desc}</p>
									<p className="fs-9px mb-0 text-white text-opacity-50">{stat.time_updated}</p>
								</CardBody>
							</Card>
						</div>
					))}
				</div>
			</div>
			
			<div className="col-xl-8">
				<Card className="h-100">
					<CardHeader className="with-btn">
						TRAFFIC ANALYTICS
						<CardHeaderBtn />
					</CardHeader>
					
					<CardBody className="p-0">
						<div className="row gx-0">
							<div className="col-lg-8 position-relative">
								<div id="map-container" style={{ height: '344px'}}></div>
								<div className="position-absolute text-white fs-10px bottom-0 end-0 start-0 p-15px d-flex align-items-center">
									<Icon className="text-white fs-30px me-2" icon="solar:map-point-rotate-bold-duotone" />
									<div className="flex-1">
										Real-time data updates every 5 minutes, providing insights into visitor traffic patterns and peak times. Click on any location for detailed analytics.
									</div>
								</div>
							</div>
							<div className="col-lg-4">
								{trafficData && (
									<div className="p-3">
										{trafficData.total_visit && (
											<>
												<div className="h4 text-theme mb-0 fw-100">[{trafficData.total_visit}]</div>
												<p className="text-white fs-10px fw-semibold mb-0">TOTAL VISITS</p>
												<hr className="my-2" />
											</>
										)}
					
										<table className="w-100 text-truncate fs-10px">
											<thead>
												<tr className="text-white">
													<th className="w-50">COUNTRY</th>
													<th className="w-25 text-end">VISITS</th>
													<th className="w-25 text-end">PCT%</th>
												</tr>
											</thead>
											<tbody className="text-body text-opacity-75">
												{trafficData.country && trafficData.country.length > 0 ? (
													trafficData.country.map((country, index) => (
														<tr key={index} className={country.class}>
															<td>{country.name}</td>
															<td className="text-end">{country.visits}</td>
															<td className="text-end">{country.pct}</td>
														</tr>
													))
												) : (
													<tr>
														<td colSpan="3">No records found</td>
													</tr>
												)}
											</tbody>
										</table>
					
										<hr className="my-2" />
					
										<table className="w-100 text-truncate fs-10px">
											<thead>
												<tr className="text-white">
													<th className="w-50">BROWSER</th>
													<th className="w-25 text-end">NO/m</th>
													<th className="w-25 text-end">PCT%</th>
												</tr>
											</thead>
											<tbody className="text-body text-opacity-75">
												{trafficData.browser && trafficData.browser.length > 0 ? (
													trafficData.browser.map((browser, index) => (
														<tr key={index} className={browser.class}>
															<td>{browser.name}</td>
															<td className="text-end">{browser.no}</td>
															<td className="text-end">{browser.pct}</td>
														</tr>
													))
												) : (
													<tr>
														<td colSpan="3">No records found</td>
													</tr>
												)}
											</tbody>
										</table>
									</div>
								)}
							</div>
						</div>
					</CardBody>
				</Card>
			</div>
			
			<div className="col-xl-4">
				<div className="row gy-2">
					{securityData && (
						<div className="col-lg-12">
							<Card className="h-100">
								<CardHeader className="with-btn">
									SECURITY SETTINGS
									<CardHeaderBtn />
								</CardHeader>
	
								<CardBody>
									<table className="table-py-1px fs-10px fw-semibold text-white">
										<tbody>
											{securityData.map((log, index) => (
												<tr key={index}>
													<td className="pe-3 text-white text-opacity-50">{log.name}:</td>
													<td>{log.value}</td>
												</tr>
											))}
										</tbody>
									</table>
								</CardBody>
							</Card>
						</div>
					)}
					
					{threatData && (
						<div className="col-lg-12">
							<Card className="h-100">
								<CardHeader className="with-btn">
									THREAT DETECTION
									<CardHeaderBtn />
								</CardHeader>
		
								<CardBody>
									{threatData.stats && (
										<div className="row mb-3 fs-10px pt-1px">
											{threatData.stats.map((stat, index) => (
												<div className="col-4" key={index}>
													<div className="d-flex flex-column justify-content-center text-center">
														<div className="w-40px h-40px mx-auto">
															<Chart type="donut" options={chartOptions} series={stat.chart_data} height="40" />
														</div>
														<div className="mt-2">{stat.name}</div>
														<div className="text-white">{stat.value}</div>
													</div>
												</div>
											))}
										</div>
									)}
		
									{threatData.log && <hr className="my-2" />}
		
									{threatData.log && (
										<table className="w-100 text-truncate fs-10px table-py-1px">
											<thead>
												<tr className="text-white">
													<th width="40%">DETECTION SRC.</th>
													<th width="25%">TYPE</th>
													<th width="25%">SEVERITY</th>
													<th width="10%">TOTAL</th>
												</tr>
											</thead>
											<tbody>
												{threatData.log.map((log, index) => (
													<tr key={index}>
														<td>{log.src}</td>
														<td>{log.type}</td>
														<td>{log.level}</td>
														<td>{log.total}</td>
													</tr>
												))}
											</tbody>
										</table>
									)}
								</CardBody>
							</Card>
						</div>
					)}
				</div>
			</div>
			
			{businessData && (
        <div className="col-xl-4 col-lg-6">
          <Card className="h-100">
            <CardHeader className="with-btn">
              BUSINESS METRICS
              <CardHeaderBtn />
            </CardHeader>

            <CardBody>
              <div className="row g-3">
                {businessData.map((stat, index) =>
                  index < 3 ? (
                    <div className="col-4" key={index}>
                      <div className="d-flex align-items-center">
                        <div className="fs-32px text-theme d-flex w-40px">
                          <Icon icon={stat.icon} />
                        </div>
                        <div className="flex-1">
                          <div className="fs-10px fw-semibold text-white text-opacity-50 mb-1">
                            {stat.title}
                          </div>
                          <div className="h6 mb-0 fw-base">{stat.value}</div>
                        </div>
                      </div>
                    </div>
                  ) : null
                )}
              </div>

              <hr className="invisible m-0" />
              <hr />

              <div className="row g-3">
                {businessData.map((stat, index) =>
                  index > 2 ? (
                    <div className="col-4" key={index}>
                      <div className="d-flex align-items-center">
                        <div className="fs-32px text-theme d-flex w-40px">
                          <Icon icon={stat.icon} />
                        </div>
                        <div className="flex-1">
                          <div className="fs-10px fw-semibold text-white text-opacity-50 mb-1">
                            {stat.title}
                          </div>
                          <div className="h6 mb-0 fw-base">{stat.value}</div>
                        </div>
                      </div>
                    </div>
                  ) : null
                )}
              </div>
            </CardBody>
          </Card>
        </div>
      )}
      
      {salesData && (
				<div className="col-xl-4 col-lg-6">
					<Card className="h-100">
						<CardHeader className="with-btn">
							SALES PERFORMANCE
							<CardHeaderBtn />
						</CardHeader>
		
						<CardBody className="text-white fs-10px fw-semibold">
							{salesData.map((sales, index) => (
								<div className="d-flex align-items-center mb-1" key={index}>
									<span
										className={`${sales.noClass} w-15px h-15px d-flex align-items-center justify-content-center`}
									>
										{sales.no}
									</span>
									<span className="flex-1 ps-2">{sales.country}</span>
									<span className="w-110px">
										<div className="progress h-3px bg-black mt-1px">
											<div
												className={`${sales.percentageClass} progress-bar`}
												style={{ width: sales.percentage }}
											></div>
										</div>
									</span>
									<span className="w-50px text-end">{sales.sales}</span>
								</div>
							))}
						</CardBody>
					</Card>
				</div>
      )}
      
      {operationalData && (
				<div className="col-xl-4">
					<Card className="h-100">
						<CardHeader className="with-btn">
							OPERATIONAL OVERVIEW
							<CardHeaderBtn />
						</CardHeader>
	
						<CardBody>
							<div className="d-flex fs-10px">
								<div className="fs-40px text-theme">
									<Icon icon="material-symbols-light:precision-manufacturing-outline-sharp" />
								</div>
								<div className="flex-1 ps-3">
									<div>
										Increased weekly production rate by{' '}
										<span className={`${operationalData.percentageClass} fw-semibold`}>
											{operationalData.percentage}
										</span>
										, reflecting improved operational performance.
									</div>
									<hr className="invisible m-0" />
									<hr />
									<div className="row mb-4px text-truncate">
										<div className="col-6">
											<div className="d-flex align-items-center">
												<div className="text-body text-opacity-50 w-70px">CURRENT:</div>
												<div className="text-white fw-semibold flex-1">
													{operationalData.current}
												</div>
											</div>
											<div className="d-flex align-items-center">
												<div className="text-body text-opacity-50 w-70px">TARGET:</div>
												<div className="text-white fw-semibold flex-1">
													{operationalData.target}
												</div>
											</div>
										</div>
										<div className="col-6">
											<div className="d-flex align-items-center">
												<div className="text-body text-opacity-50 w-70px">RATE:</div>
												<div className="text-white fw-semibold flex-1">
													{operationalData.rate}
												</div>
											</div>
											<div className="d-flex align-items-center">
												<div className="text-body text-opacity-50 w-70px">PREV WEEK:</div>
												<div className="text-white fw-semibold flex-1">
													{operationalData.prev_week}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</CardBody>
					</Card>
				</div>
			)}
			
			{socialData && (
				<div className="col-xl-4 col-lg-6">
					<Card className="h-100">
						<CardHeader className="with-btn">
							SALES BY SOCIAL SOURCE
							<CardHeaderBtn />
						</CardHeader>
						
						<CardBody>
							<div className="d-flex align-items-center mb-3">
								<div className="flex-1">
									<div className="mb-0 h4 fw-300 text-theme flex-1">
										{socialData.total}
									</div>
									<div className="text-white text-opacity-50 fs-10px fw-semibold">
										<span className="text-white">{socialData.percentage}</span> vs yesterday
									</div>
								</div>
							</div>
							
							<hr />
							
							{socialData.source && 
								socialData.source.map((source, index) => (
									<div key={index} className="d-flex align-items-center text-white mb-2">
										<div className="w-20px h-20px fs-12px bg-white bg-opacity-10 text-white d-flex align-items-center justify-content-center">
											<i className={source.icon}></i>
										</div>
										<div className="flex-1 px-3 fs-10px">{source.name}</div>
										<div className="text-white fw-semibold small">{source.sales}</div>
									</div>
								))
							}
						</CardBody>
					</Card>
				</div>
   		)}
   		
   		{productsData && (
				<div className="col-xl-4 col-lg-6">
					<Card>
						<CardHeader className="with-btn">
							TOP PRODUCTS BY UNITS SOLD
							<CardHeaderBtn />
						</CardHeader>
						
						<CardBody>
							{productsData.map((product, index) => (
								<div key={index} className="d-flex align-items-center mb-3 fs-10px">
									<div className="bg-opacity-10 bg-white fs-20px w-30px h-30px text-white d-flex align-items-center justify-content-center">
										<Icon icon={product.icon} />
									</div>
									<div className="text-truncate ps-3 flex-1">
										<div className="text-white fw-semibold">{product.title}</div>
										<div className="text-white text-opacity-50">{product.price}</div>
									</div>
									<div className="text-center">
										<div className="text-white fw-semibold fs-12px">{product.sold}</div>
										<div className="text-white text-opacity-50 fs-7px fw-semibold mb-1">SOLD</div>
									</div>
								</div>
							))}
						</CardBody>
					</Card>
				</div>
			)}
			
			{marketingData && (
				<div className="col-xl-4">
					<Card className="h-100">
						<CardHeader className="with-btn">
							MARKETING CAMPAIGN
							<button className="card-header-btn"></button>
						</CardHeader>
						<CardBody>
							{marketingData.statsData && (
								<div className="row">
									{marketingData.statsData.map((stat, index) => (
										<div key={index} className="col-6">
											<div className="fw-semibold text-white text-opacity-50 fs-10px mb-2">{stat.title}</div>
											<div className="h4 text-theme mb-2">{stat.value}</div>
											{stat.desc && (
												<div className="fs-10px">
													{stat.desc.map((desc, descIndex) => (
														<div key={descIndex}>
															<span className="text-white fw-semibold">{desc.value}</span> {desc.name}
														</div>
													))}
												</div>
											)}
										</div>
									))}
								</div>
							)}
							
							{marketingData.adsData && (
								<div>
									{marketingData.adsData.map((ad, adIndex) => (
										<div key={adIndex}>
											<hr />
											<div className="d-flex align-items-center">
												<div className="w-60px">
													<div className="h-60px d-flex align-items-center justify-content-center bg-white bg-opacity-10 text-white fs-36px">
														<Icon icon={ad.icon} />
													</div>
												</div>
												<div className="flex-1 ps-3 fs-10px text-truncate text-white">
													<div className="fw-semibold">{ad.title}</div>
													<div className="text-white text-opacity-50">{ad.date}</div>
													<div className="d-flex align-items-center">
														<div className="flex-grow-1">
															<div className="progress h-4px bg-white bg-opacity-10">
																<div className="progress-bar progress-bar-striped bg-theme" style={{ width: ad.progress }}></div>
															</div>
														</div>
														<div className="ms-2 w-30px text-center">{ad.progress}</div>
													</div>
													<div className="text-white text-opacity-50 text-truncate">{ad.desc}</div>
												</div>
											</div>
										</div>
									))}
								</div>
							)}
						</CardBody>
					</Card>
				</div>
			)}
		</div>
	)
};

export default Dashboard;